export enum DepositMethodsEnum {
    Pix = 'pix',
    Ted = 'ted',
}